import {
  setPrinciples,
  setPrinciple,
  setPrincipleSearchResults,
} from "reduxStore/state";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Fetch all principles
export const fetchPrinciples = () => async (dispatch, getState) => {
  try {
    const token = getState().token;

    const response = await fetch(`${BASE_URL}/principles/principles`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) throw new Error("Failed to fetch principles");

    const principles = await response.json();
    dispatch(setPrinciples(principles));
    return principles;
  } catch (error) {
    console.error("Error while fetching principles:", error);
    return { error: error.message };
  }
};

// Fetch a single principle by ID
export const fetchPrinciple = (id) => async (dispatch, getState) => {
  try {
    const token = getState().token;

    const response = await fetch(`${BASE_URL}/principles/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) throw new Error("Failed to fetch principle");

    const principle = await response.json();
    dispatch(setPrinciple(principle));
    return principle;
  } catch (error) {
    console.error("Error while fetching principle:", error);
    return { error: error.message };
  }
};

// Create a new principle
export const createPrinciple = (data) => async (dispatch, getState) => {
  try {
    const token = getState().token;

    const response = await fetch(`${BASE_URL}/principles`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) throw new Error("Failed to create principle");

    const principle = await response.json();
    dispatch(setPrinciple(principle));
    dispatch(fetchPrinciples());
    return principle;
  } catch (error) {
    console.error("Error while creating principle:", error);
    return { error: error.message };
  }
};

// Update a principle by ID
export const updatePrinciple = (id, data) => async (dispatch, getState) => {
  try {
    const token = getState().token;

    const response = await fetch(`${BASE_URL}/principles/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) throw new Error("Failed to update principle");

    const principle = await response.json();
    dispatch(setPrinciple(principle));
    dispatch(fetchPrinciples());
    return principle;
  } catch (error) {
    console.error("Error while updating principle:", error);
    return { error: error.message };
  }
};

// Delete a principle by ID
export const deletePrinciple = (id) => async (dispatch, getState) => {
  try {
    const token = getState().token;

    const response = await fetch(`${BASE_URL}/principles/${id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) throw new Error("Failed to delete principle");

    return id;
  } catch (error) {
    console.error("Error while deleting principle:", error);
    return { error: error.message };
  }
};

// Search principles
export const searchPrinciples = (search) => async (dispatch, getState) => {
  try {
    const token = getState().token;

    const response = await fetch(
      `${BASE_URL}/principles/search?search=${search}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) throw new Error("Failed to search principles");

    const principles = await response.json();
    dispatch(setPrincipleSearchResults(principles));
    return principles;
  } catch (error) {
    console.error("Error while searching principles:", error);
    return { error: error.message };
  }
};
